import { render, staticRenderFns } from "./fcwpLangs.vue?vue&type=template&id=3051ed3a&scoped=true&"
import script from "./fcwpLangs.vue?vue&type=script&lang=js&"
export * from "./fcwpLangs.vue?vue&type=script&lang=js&"
import style0 from "./fcwpLangs.vue?vue&type=style&index=0&id=3051ed3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3051ed3a",
  null
  
)

export default component.exports